module.exports = __webpack_public_path__ + "img/cross-red.133cfcdc.svg";